import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import clsx from 'clsx';
import { Icon } from '../../../../layout/Icon.jsx';

const PALETTE = ['#FF7A1A', '#FFB627', '#06B6D4', '#EC4899', '#22C55E', '#8B5CF6', '#EF4444', '#0E7490'];

function defaultsFrom(c) {
  return {
    name: c?.name || '',
    parentId: c?.parentId || c?.parent?._id || '',
    color: c?.color || PALETTE[0],
    icon: c?.icon || '',
    isActive: c?.isActive !== false
  };
}

export function CategoryForm({ open, category, parents = [], onClose, onSubmit, submitting, kind = 'expense' }) {
  const isEdit = !!category;
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors }
  } = useForm({ defaultValues: defaultsFrom(category) });

  useEffect(() => {
    if (open) reset(defaultsFrom(category));
  }, [open, category, reset]);

  const color = watch('color');

  if (!open) return null;

  const submit = (values) => {
    if (!values.name?.trim()) return;
    onSubmit?.({
      name: values.name.trim(),
      parentId: values.parentId || null,
      color: values.color,
      icon: values.icon || null,
      isActive: !!values.isActive
    });
  };

  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center p-4"
      style={{ background: 'rgba(0,0,0,.45)' }}
    >
      <form
        className="card w-[460px] max-w-full max-h-[calc(100vh-2rem)] flex flex-col min-h-0 overflow-hidden"
        onClick={(e) => e.stopPropagation()}
        onSubmit={handleSubmit(submit)}
        noValidate
      >
        <div className="card-h shrink-0">
          <h3 className="text-[15px] font-bold flex-1">
            {isEdit ? 'تعديل فئة' : kind === 'revenue' ? 'فئة إيراد جديدة' : 'فئة مصروف جديدة'}
          </h3>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            <Icon name="x" size={14} />
          </button>
        </div>

        <div className="card-b space-y-3 overflow-y-auto flex-1 min-h-0">
          <div>
            <label className="block text-xs font-semibold text-ink-2 mb-1">الاسم *</label>
            <input
              className={clsx('input', errors.name && 'border-red')}
              {...register('name', { required: true })}
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-ink-2 mb-1">فئة أب (اختياري)</label>
            <select className="input" {...register('parentId')}>
              <option value="">— لا شيء —</option>
              {parents
                .filter((p) => (p._id || p.id) !== (category?._id || category?.id))
                .map((p) => (
                  <option key={p._id || p.id} value={p._id || p.id}>{p.name}</option>
                ))}
            </select>
          </div>

          <div>
            <label className="block text-xs font-semibold text-ink-2 mb-1">اللون</label>
            <div className="flex flex-wrap gap-1.5">
              {PALETTE.map((c) => (
                <button
                  key={c}
                  type="button"
                  className={clsx(
                    'w-7 h-7 rounded-[8px] border-2 transition-all',
                    color === c ? 'border-ink' : 'border-transparent'
                  )}
                  style={{ background: c }}
                  onClick={() => setValue('color', c)}
                />
              ))}
            </div>
          </div>

          <label className="flex items-center gap-2 cursor-pointer text-[13px] text-ink-2">
            <input type="checkbox" className="accent-orange" {...register('isActive')} />
            فعّالة
          </label>
        </div>

        <div className="card-h border-b-0 border-t flex justify-end gap-2 shrink-0 bg-white">
          <button type="button" className="btn" onClick={onClose} disabled={submitting}>
            إلغاء
          </button>
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? 'جاري...' : isEdit ? 'حفظ' : 'إنشاء'}
          </button>
        </div>
      </form>
    </div>
  );
}
